<template>
    <div class="schedule">
        <div class="weeks row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${weeks}, 1fr)` }'>
            <h5 class='label'>Weeks</h5>
            <div class='item' v-for='n in weeks' :key='n'>{{n}}</div>
        </div>
        <div class="conceptual-arts row" :style='{ gridTemplateColumns: `${labelWidth} repeat(1, 1fr)` }'>
            <h5 class='label'>Conceptual Arts</h5>
            <div class='item'>Development Supervision</div>
        </div>
        <div class="writing row" :style='{ gridTemplateColumns: `${labelWidth} repeat(${writing.length}, 1fr)` }'>
            <h5 class='label'>Writing</h5>
            <div class='item' v-for='n in writing'>
                {{n}}
            </div>
        </div>

        <div class="character row" :style='{ gridTemplateColumns: `${labelWidth} repeat(24, 1fr)` }'>
            <h5 class='label'>Character &amp; Color Keys</h5>
            <div class='item'>Character &amp; Color Keys</div>
        </div>

        <div class="background row" :style='{ gridTemplateColumns: `${labelWidth} repeat(24, 1fr)` }'>
            <h5 class='label'>Background &amp; Color Keys</h5>
            <div class='item'>Background &amp; Color Keys</div>
        </div>

        <div class="teaser row" :style='{ gridTemplateColumns: `${labelWidth} repeat(24, 1fr)` }'>
            <h5 class='label'>Teaser (90 Seconds)</h5>
            <div class='item'>Teaser (90 Seconds)</div>
        </div>

        <div class="presentation row" :style='{ gridTemplateColumns: `${labelWidth} repeat(24, 1fr)` }'>
            <h5 class='label'>Presentation Materials</h5>
            <div class='item'>Brochures &amp; Prints</div>
        </div>

        <div class="fees row" :style='{ gridTemplateColumns: `${labelWidth} repeat(24, 1fr)` }'>
            <h5 class='label'>Fees Schedule</h5>
            <div class='item' v-for='n in fees' v-html='n' />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            labelWidth: '300px',
            weeks: 24,
            writing: ['Brainstorming', '1st Notes', '2nd Notes', '3rd Notes', '4th Notes', '5th Notes', '6th Notes'],
            fees: ['Kick Off: 100K', 'Week 7: $75K', 'Week 13: $75K', 'Week 19: $50K']
        }
    }
}
</script>

<style lang='scss'>

@import '../styles/mixins';
@import '../styles/vars';

.schedule {
    display: grid;
    height: 100%;
}

.row {
    display: grid;
    grid-gap: 1px;
    margin: 0 0 1px;
}

.item {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
}

.label {
    margin: 0;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: 0 0 0 10%;
    font-weight: 800;
}

.item,
.label {
    @include fluid-type(320px, 1920px, 10px, 14px);
}

.weeks .label { background: rgba($color-blue, 0.3); }
.weeks .item { background: rgba($color-blue, 0.3); }

.conceptual-arts .label { background: rgba($color-orange, 0.3); }
.conceptual-arts .item { background: rgba($color-orange, 0.3); } 

.writing .label { background: rgba($color-gold, 0.3); }
.writing .item { background: rgba($color-gold, 0.3); } 

.character .label { background: rgba($color-green, 0.3); }
.character .item { background: rgba($color-green, 0.3); grid-column: 7/14; } 

.background .label { background: rgba($color-gold, 0.6); }
.background .item { background: rgba($color-gold, 0.6); grid-column: 10/18; } 

.teaser .label { background: rgba($color-orange, 0.6); }
.teaser .item { background: rgba($color-orange, 0.6); grid-column: 13/24; } 

.presentation .label { background: rgba($color-cyan, 0.6); }
.presentation .item { background: rgba($color-cyan, 0.6); } 
.presentation .item:nth-of-type(1) { grid-column: 20/26; } 

.fees .label { background: rgba($color-gray, 0.6); }
.fees .item { background: rgba($color-gray, 0.6); } 

.fees .item:nth-of-type(1) { grid-column: 2/5; } 
.fees .item:nth-of-type(2) { grid-column: 8/11; } 
.fees .item:nth-of-type(3) { grid-column: 14/17; } 
.fees .item:nth-of-type(4) { grid-column: 20/23; } 

/*$color-blue: #4a70e3;
$color-cyan: #8eeaef;
$color-gold: #f7c55c;
$color-gray: #d0cece;
$color-orange: #ef6943;
$color-green: #7ad5b3;*/
</style>


// WEBPACK FOOTER //
// src/components/Schedule.vue